import { Controller } from "@hotwired/stimulus"

// Enables dependent fields only while the trigger select holds the expected
// value ("true" unless overridden via data-conditional-field-show-when-value).
// Disabled fieldsets are greyed out and excluded from form submission —
// same idiom as the sister delivery app.
export default class extends Controller {
  static targets = ["trigger", "dependent"]
  static values = { showWhen: { type: String, default: "true" } }

  connect() {
    this.toggle()
  }

  toggle() {
    const enabled = this.triggerTarget.value === this.showWhenValue
    this.dependentTargets.forEach((el) => (el.disabled = !enabled))
  }
}
